import React from 'react';
import {
  Dialog,
  DialogBackdrop,
  DialogContent,
  DialogFooter,
  PrimaryButton,
  WarningButton,
} from '@tricor-digital-team/vistra-design-system';

const RemoveStep = ({ dialog, handleRemove }) => {
  return (
    <DialogBackdrop id="dialog-backdrop" {...dialog}>
      <Dialog
        id="dialog-container"
        hideOnEsc={false}
        hideOnClickOutside={false}
        {...dialog}
        aria-label="Example Label"
        size={'medium'}
      >
        <DialogContent>
          <div className="flex justify-between items-center mt-4">
            <div className="text-black text-2xl font-normal">Are you sure you want to remove this individual?</div>
          </div>
          <div className="text-black mt-6 text-base">
            This action will remove their details from the list and cannot be undone.
          </div>
        </DialogContent>
        <DialogFooter>
          <div className="flex justify-between items-center w-full py-3">
            <WarningButton label="Remove" onClick={handleRemove} size="large" />
            <PrimaryButton label="Go back" onClick={() => dialog.hide()} size="large" />
          </div>
        </DialogFooter>
      </Dialog>
    </DialogBackdrop>
  );
};
export default RemoveStep;
